var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',[_c('el-col',[_c('h1',[_vm._v("Toevoegen van een nieuwe organisatie")])])],1),_c('el-row',[_c('el-col',[_c('organisation-form',{on:{"submitted":_vm.addOrganisation}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }